// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorMessage_wrap__3IJJc"};